export default "__VITE_ASSET__PDQSsBg8__"